import React, { useEffect, useState } from "react";
import { Phone, X, MessageCircle, CheckCircle2 } from "lucide-react";
import service from "../../Service/Service";
import "./CallOnlyDealsModal.css";

const PHONE = "03338820922";
const WHATSAPP = "923338820922";

const CallOnlyDealsModal = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(false);
  const [phone, setPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (dismissed) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phone.trim()) return;
    setSubmitting(true);
    setError("");
    try {
      await service.saveCallbackRequest(phone.trim());
      setSubmitted(true);
    } catch {
      try {
        await service.addContact({
          name: "Callback Request",
          email: "callback@skysale.pk",
          phone: phone.trim(),
          subject: "Call Only Deals",
          message: `Please call back: ${phone.trim()}`,
        });
        setSubmitted(true);
      } catch {
        setError("Something went wrong. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  const dismiss = () => {
    setDismissed(true);
    setMobileExpanded(false);
  };

  const cardBody = (
    <div className="call-deals-card">
      <div className="call-deals-card-header">
        <div>
          <p className="label">Exclusive Offer</p>
          <h3 className="title">Call Only Deals</h3>
        </div>
        <button type="button" className="call-deals-close" onClick={dismiss} aria-label="Close">
          <X />
        </button>
      </div>

      <div className="call-deals-card-body">
        {submitted ? (
          <div className="call-deals-success">
            <CheckCircle2 />
            <p className="ok-title">We'll call you back!</p>
            <p className="ok-text">Our expert will reach out to you shortly with the best deals.</p>
          </div>
        ) : (
          <>
            <p className="call-deals-desc">
              Our travel experts have access to unpublished fares. Leave your number and we'll call you with the best deal.
            </p>

            <form onSubmit={handleSubmit} className="call-deals-form">
              <div className="call-deals-input-wrap">
                <Phone />
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="+92 300 0000000"
                />
              </div>
              <button
                type="submit"
                disabled={submitting || !phone.trim()}
                className="call-deals-submit"
              >
                {submitting ? "Sending..." : "Request a Call"}
              </button>
              {error && <p className="call-deals-error">{error}</p>}
            </form>

            <div className="call-deals-divider">
              <div className="call-deals-divider-line" />
              <span>or</span>
              <div className="call-deals-divider-line" />
            </div>

            <div className="call-deals-actions">
              <a href={`tel:${PHONE}`} className="call-deals-btn blue">
                <Phone />
                Call Our Expert
              </a>
              <a
                href={`https://wa.me/${WHATSAPP}`}
                target="_blank"
                rel="noopener noreferrer"
                className="call-deals-btn green"
              >
                <MessageCircle />
                WhatsApp Us
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );

  return (
    <div className="call-deals-root">
      {/* Desktop: floating card bottom-left */}
      <div className={`call-deals-desktop ${visible ? "visible-anim" : "hidden-anim"}`}>
        {cardBody}
      </div>

      {/* Mobile: floating circular call button */}
      <div className={`call-deals-mobile ${visible ? "visible-anim" : "hidden-anim"}`}>
        <div className={`call-deals-expand-wrap ${mobileExpanded ? "open" : "closed"}`}>
          <div className="call-deals-expand-inner">
            {cardBody}
          </div>
        </div>

        {!mobileExpanded && (
          <button type="button" className="call-deals-tab" onClick={() => setMobileExpanded(true)} aria-label="Call Deals">
            <span
              className="call-deals-tab-close"
              role="button"
              tabIndex={0}
              aria-label="Dismiss"
              onClick={(e) => {
                e.stopPropagation();
                dismiss();
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.stopPropagation();
                  dismiss();
                }
              }}
            >
              <X />
            </span>
            <span className="call-deals-tab-icon">
              <Phone />
            </span>
            <span className="call-deals-tab-label">Call Deals</span>
          </button>
        )}

        {mobileExpanded && (
          <button
            type="button"
            className="call-deals-collapse"
            onClick={() => setMobileExpanded(false)}
            aria-label="Collapse"
          >
            <X />
          </button>
        )}
      </div>
    </div>
  );
};

export default CallOnlyDealsModal;
